import {
  createGenericSelectContentEvent,
  SelectContentEvent,
} from '@moonpig/web-core-analytics'
import { PageTypeEnum } from '@moonpig/web-shared-products'
import { Price } from '../components/types'
import { GetUpcomingOccasions_me_customer_recommendations_products as RecommendedProducts } from '../queries/types-graphql'

type Variant = {
  title: string
  price: Price
}

type MasterVariant = Variant & {
  inStock: boolean
}

type Breadcrumb = {
  label: string
  url: string
}

export type ModalOpenGAEventDetailsProduct = {
  id: string
  title: string
  category: {
    name: string
  }
}

export type ModalVPVEventDetailsProduct = {
  id: string
  title: string
  customisable: boolean
  masterVariant: MasterVariant
  category: {
    name: string
    slug: string
  }
  slug: string
  isFavourite?: boolean
  productIndex?: number
}

export type ResultsLoadedGAEventDetailsProduct = ModalVPVEventDetailsProduct

export const loadMoreGAEventDetails = (productCount: number) => {
  return createGenericSelectContentEvent({
    eventCategory: 'gallery action',
    eventAction: 'load more',
    eventLabel: productCount.toString(),
  })
}

export const generateBreadcrumbsClickGAEvent = (
  breadcrumbs?: Array<Breadcrumb>,
): SelectContentEvent => {
  const getBreadcrumbHierarchy = () => {
    if (!breadcrumbs) return ''
    const result: string[] = []
    breadcrumbs.forEach((breadcrumb: Breadcrumb) =>
      result.push(breadcrumb.label),
    )
    return result.join(' > ')
  }

  const breadcrumbHierarchy = getBreadcrumbHierarchy()?.toLocaleLowerCase()
  return {
    event: 'select_content',
    content_data: {
      content_type: `breadcrumb | ${breadcrumbHierarchy}`,
    },
    event_data: {
      category: 'site breadcrumb selection',
      action: 'global navigation link click',
      label: breadcrumbHierarchy,
      non_interaction: true,
      value: undefined,
    },
  }
}

export type RecentlyViewedGAEventProduct = {
  id: string
  title: string
  category: {
    name: string
  }
  masterVariant: {
    price: {
      centAmount: number
    }
  }
}

export type ProductsInRecentlyViewed = {
  products: RecentlyViewedGAEventProduct[]
  pageType: string
}

export type NumberOfProductsInRecentlyViewed = {
  productIndex: number
  productCount: number
  pageTitle: string
}

export type RecommendedForYouCarouselImpressions = {
  type: string
  products: RecommendedProducts[]
}

export const ExpandOrMinimiseRecentlyViewedGAEvent = (
  expandOrMinimise: string,
) => {
  return createGenericSelectContentEvent({
    eventCategory: 'product action',
    eventAction: 'list click',
    eventLabel: `Recently Viewed | footer carousel | ${expandOrMinimise}`,
  })
}

export const generateDepartmentHeadersClickGAEvent = ({
  searchTerm,
  departmentTitle,
  departmentCount,
  pageType,
  pageTitle,
}: {
  searchTerm: string
  departmentTitle: string
  departmentCount: number
  pageType: string
  pageTitle: string
}) => {
  return createGenericSelectContentEvent({
    eventCategory:
      pageType === PageTypeEnum.GALLERY ? 'gallery action' : 'search',
    eventAction: 'global header click',
    eventLabel: `${searchTerm || pageTitle} in ${departmentTitle} | ${departmentCount}`,
  })
}
